import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import images from './images/images';

const FileUpload = ({
  allowedFileTypes,
  maxFileCount,
  uploadedFiles,
  explanationText,
  errorMessage,
  onFileChange,
  onFileRemove,
  disabled,
}) => {
  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      onFileChange(files);
      // Clear the input so the same file can be selected again
      e.target.value = '';
    }
  };

  const handleRemoveFile = (index) => {
    onFileRemove(index);
  };

  // Parse allowed file types for accept attribute
  const getAcceptAttribute = () => {
    if (!allowedFileTypes || allowedFileTypes.trim() === '') {
      return undefined;
    }
    // Convert comma-separated extensions to accept format
    // e.g., "pdf,jpg,png" -> ".pdf,.jpg,.png"
    return allowedFileTypes
      .split(',')
      .map(type => `.${type.trim()}`)
      .join(',');
  };

  return (
    <div className="file-upload-section">
      {explanationText && (
        <div className="file-upload-explanation">
          <p>{explanationText}</p>
        </div>
      )}

      {/* Uploaded files list - MOVED ABOVE upload button */}
      {uploadedFiles && uploadedFiles.length > 0 && (
        <div className="uploaded-files-list">
          {uploadedFiles.map((file, index) => (
            <div key={index} className="uploaded-file-item">
              <div className="file-info">
                <span className="file-name">{file.name}</span>
              </div>
              <button
                type="button"
                onClick={() => handleRemoveFile(index)}
                disabled={disabled}
                className="remove-file-btn"
              >
                <Image src={images.removeFile} alt="remove file" className="remove-icon" />
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Upload button */}
      <div className="file-upload-input">
        <input
          type="file"
          multiple
          accept={getAcceptAttribute()}
          onChange={handleFileSelect}
          disabled={disabled || uploadedFiles.length >= maxFileCount}
          id="file-upload"
          style={{display: 'none'}}
        />
        <label
          htmlFor="file-upload"
          className={`file-upload-button ${uploadedFiles.length >= maxFileCount ? 'disabled' : ''}`}
        >
          <Image src={images.fileUpload} alt="upload icon" className="upload-icon" />
          {uploadedFiles.length > 0 ? 'צירוף קובץ נוסף' : 'צירוף קובץ'}
        </label>
      </div>

      <span className={`file-count-info ${errorMessage ? 'has-error' : ''}`}>
        {errorMessage
          ? `ניתן לצרף עד ${maxFileCount} קבצים. כדי להעלות קובץ נוסף, יש למחוק קובץ קיים`
          : `ניתן לצרף עד ${maxFileCount} קבצים`
        }
      </span>
    </div>
  );
};

export default FileUpload;

